import React, { useState, useEffect, useContext } from "react";
import { withRouter } from "react-router-dom";
import { UserContext } from "../userContext";
import { db, fb } from "../firebase";
import Navbar from "../components/navbar";
import ChatsList from "../components/chatsList";
import ChatView from "../components/chatView";
import NewChat from "./../components/newChat";

const Dashboard = ({ history }) => {
  const { user } = useContext(UserContext).user;
  const [selectedChat, setSelectedChat] = useState(null);
  const [newChatFormShow, setNewChatFormShow] = useState(false);
  const [email, setEmail] = useState(null);
  const [chats, setChats] = useState([]);

  useEffect(() => {
    if (!user) return history.push("/");

    setEmail(user.email);
    async function getChats() {
      await db
        .collection("chats")
        .where("users", "array-contains", user.email)
        .onSnapshot(async (res) => {
          const userchats = res.docs.map((doc) => doc.data());
          await setChats(userchats);
        });
      await db.collection("users").doc(user.email).update({
        isOnline: true,
      });
    }
    getChats();
  }, [user, history]);

  const updateStatus = (status) => {
    db.collection("users").doc(email).update({
      isOnline: status,
    });
  };

  window.addEventListener("offline", () => {
    updateStatus(false);
  });
  window.addEventListener("online", () => {
    updateStatus(true);
  });
  window.addEventListener("beforeunload", (e) => {
    e.preventDefault();
    updateStatus(false);
  });
  if (window.innerWidth < 768) {
    if (email) {
      document.addEventListener("visibilitychange", function () {
        if (document.visibilityState === "visible") {
          updateStatus(true);
        } else {
          updateStatus(false);
        }
      });
    }
  }

  const newChat = () => {
    setNewChatFormShow(true);
    setSelectedChat(null);
  };

  const buildDocId = (friend) =>
    [email.replace("@gmail.com", ""), friend].sort().join(";");

  const clickedChatViewReceiver = (chatIndex) => {
    return (
      chats[chatIndex].messages[chats[chatIndex].messages.length - 1].sender !==
      email
    );
  };

  const messageRead = (i) => {
    const docId = buildDocId(
      chats[i].users.filter((f) => f !== email)[0].replace("@gmail.com", "")
    );
    if (clickedChatViewReceiver(i)) {
      db.collection("chats").doc(docId).update({ receiverHasRead: true });
    }
  };

  const selectChat = (i) => {
    setSelectedChat(i);
    messageRead(i);
  };

  const userIsTyping = async (i, status) => {
    const docId = buildDocId(
      chats[i].users.filter((f) => f !== email)[0].replace("@gmail.com", "")
    );
    const doc = await db.collection("chats").doc(docId).get();
    const friend = doc.data().isTyping.find((f) => f.userId !== email);

    if (status) {
      await db
        .collection("chats")
        .doc(docId)
        .update({
          isTyping: [
            { typing: true, userId: email },
            { typing: friend.typing, userId: friend.userId },
          ],
        });
    } else {
      await db
        .collection("chats")
        .doc(docId)
        .update({
          isTyping: [
            { typing: false, userId: email },
            { typing: friend.typing, userId: friend.userId },
          ],
        });
    }
  };

  const submitMessage = async (msg, imageURL, i) => {
    const docId = buildDocId(
      chats[i].users.filter((f) => f !== email)[0].replace("@gmail.com", "")
    );
    const doc = await db.collection("chats").doc(docId).get();
    const friend = doc.data().isTyping.find((f) => f.userId !== email);
    await db
      .collection("chats")
      .doc(docId)
      .get()
      .then((doc) => {
        if (doc.exists) {
          db.collection("chats")
            .doc(docId)
            .update({
              messages: fb.firestore.FieldValue.arrayUnion({
                sender: email,
                message: msg,
                image: imageURL,
                time: Date.now(),
              }),
              receiverHasRead: false,
              isTyping: [
                { typing: false, userId: email },
                { typing: friend.typing, userId: friend.userId },
              ],
            });
        } else {
          // db.collection("chats").doc(docId).set({});
        }
      })
      .catch((error) => {
        console.log("Error getting document:", error);
      });
  };
  function getChats() {
    db.collection("chats")
      .where("users", "array-contains", email)
      .onSnapshot((res) => {
        const userchats = res.docs.map((doc) => doc.data());
        setChats(userchats);
      });
  }
  const startNewChat = (obj) => {
    const docId = buildDocId(obj.sendTo.replace("@gmail.com", ""));
    db.collection("chats")
      .doc(docId)
      .set({
        receiverHasRead: false,
        users: [obj.sendTo, email],
        messages: [{ message: obj.message, sender: email, time: Date.now() }],
        isTyping: [
          { typing: false, userId: email },
          { typing: false, userId: obj.sendTo },
        ],
      });
    getChats();
    setNewChatFormShow(false);
    setSelectedChat(chats.length);
  };

  const openChat = (docUsers, msg) => {
    const chat = chats.find((c) => docUsers.every((u) => c.users.includes(u)));
    const index = chats.indexOf(chat);
    setNewChatFormShow(false);
    setSelectedChat(index);
    submitMessage(msg, index);
  };

  return (
    <div className="dashboard">
      <Navbar />
      <div className="dashboard__chats">
        <ChatsList
          history={history}
          newChat={newChat}
          setNewChatFormShow={setNewChatFormShow}
          selectChat={selectChat}
          selectedChatIndex={selectedChat}
          chats={chats}
          email={email}
        />
        {newChatFormShow && (
          <NewChat
            userEmail={email}
            buildChatId={buildDocId}
            openChat={openChat}
            startNewChat={startNewChat}
          />
        )}
        {!newChatFormShow && (
          <ChatView
            user={email}
            chat={chats[selectedChat]}
            selectedChat={selectedChat}
            newChatFormShow={newChatFormShow}
            submitMessage={submitMessage}
            messageRead={messageRead}
            userIsTyping={userIsTyping}
            db={db}
            docId={buildDocId}
          />
        )}
      </div>
    </div>
  );
};

export default withRouter(Dashboard);
